/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:e84b105b-0425-4a84-8cb2-4200c4c2e130",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_1mXmdf07K",
    "aws_user_pools_web_client_id": "5s8voip99u86lbhheh99if567h",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://pvkamgw6gvf7hci7efjuorjaga.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-3wgznt3bg5hyfngo5vff2ij4sq",
    "aws_cloud_logic_custom": [
        {
            "name": "alplatformapi",
            "endpoint": "https://v6lhvfi0j1.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        }
    ],
    "aws_user_files_s3_bucket": "alplatformstorage-bucket91653-dev",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
